import {
  // SvgIcon,
  Button,
  Popover as MenuMui,
  MenuItem,
  ListItemIcon,
  Box,
  Badge,
  // Divider,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  ArrowDropDown,
  // ArrowDropUp,
  Apps,
  FactCheck,
  History as HistoryIcon,
  // AppSettingsAlt as AppSettingsAltIcon,
  BarChart,
} from "@mui/icons-material";
import { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";
import { useSelector } from "redux/store";
import { selectPermissionAction } from "redux/slices/role";
// import { ReactComponent as StarSvg } from "assets/icons/Star_blink.svg";

export const Menu = styled(MenuMui)`
  & .MuiPaper-root {
    border-radius: 8px;
    margin-top: 17px;
    ${({ theme }) => theme.breakpoints.down("sm")} {
      margin-top: 15px;
    }
    & .MuiMenu-list {
      padding-top: 0px;
      padding-bottom: 0px;
    }
  }
  & .MuiMenuItem-root {
    color: ${({ theme }) => theme.palette.primary.main};
    &:hover {
      background-color: #f2f9ef;
    }
    font-size: 16px;
    font-weight: 600;
  }
`;

export const ButtonNavbar = styled(Button)`
  :hover {
    background: var(--background-color-hover);
  }
  border-radius: 8px;
  color: var(--color-text);
  white-space: nowrap;
`;

const MenuService = () => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const isAllowDashboard = useSelector(selectPermissionAction)("dashboard:view");
  // const isAllowedWhiteness = useSelector(selectPermissionFeature)("whiteness");
  const open = Boolean(anchorEl);
  const popoverRef = useRef(null);
  const handleClick = () => {
    setAnchorEl(popoverRef.current);
  };
  // const StarIcon = (props) => {
  //   return <SvgIcon component={StarSvg} inheritViewBox {...props} />;
  // };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseMenu = (label = "") => {
    setAnchorEl(null);
    ReactGA.event("click_navigation", {
      component: "navbar",
      link: label,
    });
  };

  return (
    <>
      <Box
        ref={popoverRef}
        onMouseEnter={handleClick}
        onMouseLeave={handleClose}
        id="box-button-beta-1"
      >
        <ButtonNavbar startIcon={<Apps />} endIcon={<ArrowDropDown />} onClick={handleClick}>
          {t("appbar.service")}
        </ButtonNavbar>
      </Box>
      <Menu
        id="basic-menu-1"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableAutoFocus
        sx={{
          pointerEvents: "none",
          // marginTop: '15px',
        }}
        PaperProps={{
          onMouseEnter: handleClick,
          onMouseLeave: handleClose,
          sx: {
            pointerEvents: "auto",
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem
          onClick={() => handleCloseMenu("inspection")}
          component={Link}
          to="/rice-inspect-option"
        >
          <ListItemIcon>
            <FactCheck fontSize="small" color="primary" />
          </ListItemIcon>
          {t("appbar.rice_quality_inspection")}
        </MenuItem>
        <MenuItem
          onClick={() => handleCloseMenu("history")}
          component={Link}
          to="/history-rice-inspect"
        >
          <ListItemIcon>
            <HistoryIcon fontSize="small" color="primary" />
          </ListItemIcon>
          {t("appbar.rice_history")}
        </MenuItem>
        {/* <MenuItem onClick={() => handleCloseMenu("setting")} component={Link} to="/setting"> */}
        {/*   <ListItemIcon> */}
        {/*     <AppSettingsAltIcon fontSize="small" color="primary" /> */}
        {/*   </ListItemIcon> */}
        {/*   {t("appbar.setting")} */}
        {/* </MenuItem> */}
        {isAllowDashboard && (
          <MenuItem onClick={() => handleCloseMenu("dashboard")} component={Link} to="/dashboard">
            <ListItemIcon>
              <BarChart fontSize="small" color="primary" />
            </ListItemIcon>
            <Badge
              badgeContent={" "}
              variant="dot"
              color="warning"
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <Box sx={{ pr: 0.5 }}>{t("appbar.statisticalData")}</Box>
            </Badge>
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default MenuService;
